
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

import AdditionalFieldsApi from '@/api/additionalFieldsApi'
const fields_api = new AdditionalFieldsApi()

import textFunctions from 'mixins/textFunctions'
import editTenderMembersMixin from 'mixins/editTenderMembersMixin.js'
import editTenderAdditionalFieldsMixin from 'mixins/editTenderAdditionalFieldsMixin.js'

import { mapGetters } from 'vuex'

import { getMinProposalsDate, getDefaultProposalsDate } from '@/plugins/tenderDates.js'
import tenderLotGroups from 'mixins/tenderLotGroups'

export default {
  mixins: [ textFunctions, editTenderMembersMixin, editTenderAdditionalFieldsMixin, tenderLotGroups ],
  data() {
    return {
      minProposalsDate: new Date(),
      mixin_newTenderTemplate: { // Если нужно контролировать свойство, добавить в mixin_getCheckChangeObject
        biddingTypeId: null,
        allowRaising: false,
        biddingType: {
          biddingTypeId: null,
          titleRu: null,
          oldCode: null,
          isSale: null,
          isPublic: null,
          initialRateAvailable: null,
          bidStepAvailable: null,
          prolongationRuleAvailable: null,
          reducedPriceAvailable: null,
          analogAvailable: null,
          allowRaising: false,
          tenderingForPercentage: null,
          isMultistage: null,
          withoutPublication: null,
        },
        bidOnAllLots: false,
        mandatoryFullBid: false,
        bidOnAllLotInGroup: false,
        bidStepType: 1,
        classificationCode: null,
        currencyOwner: 0,
        hideBestPrice: false,
        publicTenderResults: false,
        requiedAttachments: false,
        areIndividualsAllowed: null,
        tenderDescription: '',
        tenderCurrency: 'UAH',
        allowedCurrencies: null,
        tenderSubject: null,
        tenderPeriodTo: null,
        testMode: false,
        vat: false,
        isUrgent: false,
        allowParticipantBidCancellation: null,
        previousMailing: null,
        inviteFilter: 'ALL'
      },
      mixin_originTender: null, // исходное состояние тендера при входе на шаг
      spr: {
        prolongationRules: [],
      },
      oldPositions: [],
    }
  },
  methods: {
    /**
     * Обрабатывает свойство previousMailing в зависимости от настроек тендера
     * @param {Object} tender - Объект тендера
     * @returns {boolean|null} - Обработанное значение previousMailing
     */
    _processPreviousMailing(tender) {
      // Если планирование отключено, возвращаем null
      if (this.$can('set', 'tenderPublicationPlaningMode', 'DISABLE')) {
        return null
      }
      
      // Если у тендера есть расписание публикации (scheduledDate)
      if (tender?.tenderPublishedSchedule && tender.tenderPublishedSchedule.scheduledDate) {
        const result = tender.tenderPublishedSchedule.previousMailing ?? false
        // Сохраняем значение previousMailing из расписания, или false как дефолт
        return result
      }
      
      // Если нет расписания, но есть значение в самом тендере - сохраняем его
      if (tender?.previousMailing !== undefined) {
        return tender.previousMailing
      }
      
      // В остальных случаях возвращаем false
      return false
    },
    mixin_setAdditionalFieldsToLot(lot) {
      if (!lot) {
        return
      }
      lot.additional_fields = lot.additional_fields || {}

      this.additionalFieldsLots?.forEach(field => {
        if (!field) {
          return
        }
        if (lot.additional_fields[field.id]) { return }
        let fieldpProp = field?.value || field.fieldValues?.find(values => values.entityKey == lot.lotId) || {}
        let value = this.$_.cloneDeep(field)
        value.value = fieldpProp.value || ''
        value.valueId = fieldpProp.id || ''
        value.order = field.order
        lot.additional_fields[field.id] = value
      })
      this.$_.forEach(this.$_.values(lot.additional_fields), field => {
        if (!this.additionalFieldsLots?.some(el => el.id == field.id)) {
          delete lot.additional_fields[field.id]
        }
      })
      return lot
    },
    mixin_setAdditionalFieldsToLots(lots) {
      if (!lots?.length) {
        return
      }
      lots.forEach((lot, lotIndex) => {
        if (!lot) {
          return
        }
        this.mixin_setAdditionalFieldsToLot(lot)
        this.$set(lots, lotIndex, lot)
      })
    },
    /**
     * Для перехода со старого флоу.
     * В старом флоу немного другие правила формирования минимальной даты (лишний сдвиг на один день)
     * Это влияет на подсветку некорректности даты в инфо панели, блокировку кнопки публикации по старой логике (и на детальной)
     * и т.п. Для этого делаем проверку тут
     */
    mixin_isWrongDate(dateTo) {
      const daysWebTender = this.$store.getters.getTendersSettings.daysWebTender
      return new Date(dateTo).getTime() < getMinProposalsDate(daysWebTender).getTime()
    },
    async mixin_bindAdditionalFields(tender) {
      const allAdditionalFields = [...this.additionalFieldsTender || []/*, ...this.additionalFieldsLots || []*/]
      let fieldValues = allAdditionalFields.map(item => {
        let fieldValue = item.fieldValues?.find(el => el.entityKey == (tender || this.tender).tenderId)
        return {
          valueId: fieldValue?.id || '00000000-0000-0000-0000-000000000000',
          fieldId: item.id,
          entityKey: (tender || this.tender).tenderId + '',
          value: (item.value || item?.value || '') + '',
          order: item.order
        }
      })
      if (this.additionalFieldsLots?.length) {
        (tender || this.tender).lots?.forEach((lot, index) => {
          if (!lot.additional_fields) {
            return
          }
          Object.entries(lot.additional_fields)?.forEach((objectProps) => {
            if (!objectProps?.length) {
              return
            }
            fieldValues.push({
              valueId: objectProps[1].valueId || '00000000-0000-0000-0000-000000000000',
              fieldId: objectProps[1].id,
              entityKey: tender.lots[index].lotId + '',
              value: objectProps[1].value + '',
              order: objectProps[1].order
            })
          })
        })
      }

      return new Promise((resolve, reject) => {
        fields_api.bindAdditionaFiledToEntity({
          entityKey: (tender || this.tender).tenderId + '' ,
          fieldValues
        }).then(() => {
          resolve()
        })
          .catch((error) => {
            reject(error)
          })
      })
    },
    mixin_changeAdditionalFields(options) {
      if (!options) {
        return
      }

      this.$set(this.spr, `additionalFields${options.tender ? 'Tender' : 'Lots'}${options.exist ? 'Exists' : ''}`, options.value || [])
    },
    /**
     * Костыль, что б самописные компоненты вызывали trigger: 'change' у FormItem
    */
    mixin_sendChangeFormItem(refName, value) {
      this.$nextTick(() => {
        if (this.$refs[refName]) {
          this.$refs[refName].$emit.apply(this.$refs[refName], ['s.form.change'].concat(value))
        }
      })
    },
    mixin_getProlongRules() {
      this.$store.dispatch('setProlongationRule')
        .then(res => this.spr.prolongationRules = [
          {code: null, name: 'Без автопродовження'},
          ...res
        ])
        .catch(res => this.$log_error('prolongationRule',res))
    },
    removeTypename(obj) {
      return new Promise((resolve, reject) => {
        try {
          if (obj !== null && typeof obj === 'object') {
            if (Array.isArray(obj)) {
              obj.forEach((item) => {
                if (typeof item === 'object') {
                  this.removeTypename(item)
                }
              })
            } else {
              for (const prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                  if (prop === '__typename') {
                    delete obj[prop]
                  } else {
                    this.removeTypename(obj[prop])
                  }
                }
              }
            }
            resolve(obj)
          } else {
            resolve(obj)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    async removeTypenameRecursive(obj) {
      const result = { ...obj }
      try {
        return await this.removeTypename(result)
      } catch (error) {
        return result 
      }
    },
    mixin_createTender(tender) {
      this.$root.$emit('showOverlay')
      return new Promise((resolve, reject) => {
        this.removeTypenameRecursive(tender)
          .then((modifiedTender) => {
            tender_api.createTender(modifiedTender, false)
              .then((result) => resolve(result))
              .catch((err) => reject(err))
              .finally(() => this.$root.$emit('closeOverlay'))
          })
          .catch((error) => {
            reject(error)
            this.$root.$emit('closeOverlay')
          })
      })
    },
    async mixin_getCheckChangeObject(object) {
      let cloneObject = this.$_.cloneDeep(object) || {}
      cloneObject = await this.removeTypenameRecursive(cloneObject)
      const getLots = (lots) => {
        return lots?.length ? lots?.map(lot => ({
          additional_fields: lot.additional_fields || {},
          addressId: lot.addressId,
          bidStep: lot.bidStep,
          description: lot.description,
          discounts: lot.discounts,
          lotNumber: lot.lotNumber,
          lotSubject: lot.lotSubject,
          measuringUnit: lot.measuringUnit,
          minimalSubmitQuantity: lot.minimalSubmitQuantity ?? 0,
          bidPriceLimit: lot.bidPriceLimit ?? 0,
          nomenclatureId: lot.nomenclatureId,
          quantity: lot.quantity ?? 0,
          startAmount: lot.startAmount ?? 0,
        })) : []
      }

      const result = {
        additionalContactPersons: cloneObject?.additionalContactPersons?.map(i => ({
          contactId: i.contactId,
          email: i.email,
          name: i.name,
        })),
        allowParticipantBidCancellation: cloneObject.allowParticipantBidCancellation,
        allowRaising: cloneObject.allowRaising,
        areIndividualsAllowed: cloneObject.areIndividualsAllowed,
        bidOnAllLots: cloneObject.bidOnAllLots,
        mandatoryFullBid: cloneObject.mandatoryFullBid,
        bidOnAllLotInGroup: cloneObject.bidOnAllLotInGroup,
        bidStepType: cloneObject.bidStepType,
        biddingTypeId: cloneObject.biddingTypeId || cloneObject?.biddingType?.biddingTypeId,
        classificationCode: cloneObject.classificationCode,
        contactPersonId: cloneObject.contactPersonId,
        criteryCard: cloneObject.criteryCard,
        deliveryPeriodFrom: cloneObject.deliveryPeriodFrom,
        deliveryPeriodTo: cloneObject.deliveryPeriodTo,
        hideBestPrice: cloneObject.hideBestPrice,
        currencyOwner: cloneObject.currencyOwner,
        requiedAttachments: cloneObject.requiedAttachments,
        isUrgent: cloneObject.isUrgent,
        prolongRuleCode: cloneObject.prolongRuleCode,
        scheduledStart: cloneObject.scheduledStart,
        tenderCurrency: cloneObject.tenderCurrency,
        allowedCurrencies: cloneObject.allowedCurrencies,
        tenderDescription: cloneObject.tenderDescription,
        tenderPeriodTo: cloneObject.tenderPeriodTo,
        tenderProlongationRules: cloneObject.tenderProlongationRules,
        tenderPublishedSchedule: cloneObject.tenderPublishedSchedule ?? null,
        previousMailing: cloneObject.previousMailing ?? false,
        tenderSubject: cloneObject.tenderSubject,
        vat: cloneObject.vat,
        lots: getLots(cloneObject?.lots),
        lotGroups: cloneObject?.lotGroups?.length
          ? cloneObject?.lotGroups
            .map(i => ({
              id: i.id,
              title: i.title,
              description: i.description,
              lots: getLots(i.lots)
            }))
          : []
      }
      return result
    },
    /**
     * подготавливаем данные для сохранения/изменения
     * @param {*} tender
    */
    async mixin_prepareTenderToSave(tender, prepareFunction) {
      tender = this.$_.cloneDeep(tender)
      delete tender.tenderNumber
      delete tender.additionalCategories
      delete tender.existing_fields
      delete tender.additional_fields
      delete tender.category
      delete tender.tenderStatusId
      delete tender.__typename
      delete tender.organizerName
      delete tender.createdByExternalApi
      delete tender.hasBids
      delete tender.membersCount

      let scheduledDate = tender?.tenderPublishedSchedule?.scheduledDate ?? tender.scheduledStart

      if (scheduledDate) {
        tender.scheduledStart ||= scheduledDate
      }
      tender.previousMailing = this._processPreviousMailing(tender)

      tender.bidOnAllLots = this.isGroupLotsEnabled ? false : tender.bidOnAllLots
      tender.bidOnAllLotInGroup = this.isGroupLotsEnabled ? tender.bidOnAllLotInGroup : false

      delete tender.tenderPublishedSchedule
      delete tender.applicationBased
      tender.biddingTypeId = tender.biddingTypeId || tender.biddingType?.biddingTypeId
      tender.allowRaising = tender?.biddingType?.allowRaising ? !!tender.allowRaising : false
      tender.areIndividualsAllowed ??= false
      tender.allowParticipantBidCancellation ??= false
      delete tender.biddingType
      delete tender.hasRoute

      if (prepareFunction && typeof prepareFunction === 'function') {
        await prepareFunction()
      }
      tender.lots = tender?.lots?.length ? tender?.lots?.map(el => {
        el.description = el.description?.trim() || ''
        return el
      }) || [] : []
      return tender
    },
    /**
     * Вызов метода для изменения тендера
     * Все удаления служебных свойств делаем через beforeSendTender
     */
    mixin_changeTender(tender) {
      // Если previousMailing отсутствует, но должен быть - обрабатываем его здесь
      if (tender?.previousMailing === undefined && tender?.tenderPublishedSchedule) {
        tender.previousMailing = this._processPreviousMailing(tender)
      }

      tender.bidOnAllLots = this.isGroupLotsEnabled ? false : tender.bidOnAllLots
      tender.bidOnAllLotInGroup = this.isGroupLotsEnabled ? tender.bidOnAllLotInGroup : false
      
      this.$root.$emit('showOverlay')
      return new Promise((resolve, reject) => {
        if (this.$_initializeLotGroups) {
          this.$_initializeLotGroups(tender)
        }
        this.removeTypenameRecursive(tender)
          .then((modifiedTender) => {
            tender_api.editTenderDraft(modifiedTender)
              .then((res) => {
                if (!res) {
                  this.$show_error_message(this.$t('Errors.TryAgain'))
                  this.$log_error('editTenderDraft повернув null')
                  this.$root.$emit('closeOverlay')
                  reject(null)
                  return
                } else {
                  resolve(res)
                }
              })
              .catch((err) => reject(err))
            //.catch(this.checkValidEditing)
              .finally(() => this.$root.$emit('closeOverlay'))
          })
          .catch((error) => {
            reject(error)
            this.$root.$emit('closeOverlay')
          })
      })
    },
    async checkIndividualsAllowed(tender) {
      let is_sale = tender?.biddingType?.isSale

      if (!is_sale) {
        tender.areIndividualsAllowed = false
      } else if (this.$can('set', 'AllowIndividualsParticipation', 'ALWAYS')) {
        tender.areIndividualsAllowed = true
      } else if (is_sale && this.$can('set', 'AllowIndividualsParticipation', 'BY_DEFAULT')) {
        tender.areIndividualsAllowed ??= true
      } else if (this.$can('set', 'AllowIndividualsParticipation', 'NONE')) {
        tender.areIndividualsAllowed = false
      } else {
        tender.areIndividualsAllowed ??= false
      }
    },
    async checkIsAllowParticipantCancelBid(tender) {
      if (this.$can('set', 'IsAllowParticipantCancelBid', 'ALWAYS_ON')) {
        tender.allowParticipantBidCancellation = true
      } else if (this.$can('set', 'IsAllowParticipantCancelBid', 'SHOW_DEFAULT_OFF')) {
        tender.allowParticipantBidCancellation ??= false
      } else if (this.$can('set', 'IsAllowParticipantCancelBid', 'ALWAYS_OFF')) {
        tender.allowParticipantBidCancellation = false
      } else {
        tender.allowParticipantBidCancellation ??= true
      }
    },
    /**
     * Минимальная дата подачи предложений
     * */
    async mixin_getMinProposalsDate(daysWebTender, currentDateTime) {
      daysWebTender = daysWebTender || this.$store.getters.getTendersSettings.daysWebTender
      return getMinProposalsDate(daysWebTender, currentDateTime)
    },
    async mixin_getDefaultProposalsDate(daysWebTender, currentDateTime) {
      daysWebTender = daysWebTender || this.$store.getters.getTendersSettings.daysWebTender
      return getDefaultProposalsDate(daysWebTender, currentDateTime)
    },
    /**
     * Вызывается при изменении организации шаг 1 т после загрузки данных шаге 1
     * @param {*} tender
    */
    async mixin_checkTenderBySettings(tender, oldBiddingType) {
      tender = await this.removeTypenameRecursive(tender)
      const tenderBiddingType = tender?.biddingType || {}
      oldBiddingType = oldBiddingType || tenderBiddingType
      const isMultistaged =  tenderBiddingType.isMultistage
      if ( (!tenderBiddingType.prolongationRuleAvailable || isMultistaged) && tender.prolongRuleCode) {
        tender.prolongRuleCode = null
      }
      let defaultRule = this.settings?.tenderSettings?.defaultTenderProlongRules
      if (tenderBiddingType.prolongationRuleAvailable && !isMultistaged && defaultRule
          && !tender.prolongRuleCode
          && (!tender.tenderId || !oldBiddingType.prolongationRuleAvailable)) {
        tender.prolongRuleCode = defaultRule
      }

      // логика нужна для задачи https://app.clickup.com/t/8696pht67
      if (tender?.biddingType?.withoutPublication) {
        tender.tenderPeriodTo = null
      }

      tender.contactPersonId = tender.contactPersonId || this.$store.getters.getTenderContactPersons
        .find((contactPerson) => contactPerson.contactId === this.currentUser.tenderSettings.contactId)?.contactId

      if (!tenderBiddingType.canChangeCurrencyOwner && !tenderBiddingType.hasLimitBidPrice) {
        tender.currencyOwner = 0
      }
      if (tender.currencyOwner) {
        tender.tenderCurrency = 'UAH'
      }
      /**
       * Если валюту выбирает организатор или нет ограничения по выбору валюты, то не сохраняем список доступных валют
       */
      if (!tender.currencyOwner || !tender.biddingType.allowedCurrenciesSelectionByOrganizer) {
        tender.allowedCurrencies = null
      }

      if (tender.lots?.length) {
        const biddingType = tender.biddingType
        let canEditAll = this.$can('set', 'BudgetType', 'AMOUNT_AND_MINIMAL_STEP')
        let withoutStep = !biddingType?.bidStepAvailable || (!this.$can('set', 'BudgetType', 'MINIMAL_STEP') && !canEditAll) || isMultistaged
        let withoutPrice = !biddingType?.initialRateAvailable || (!this.$can('set', 'BudgetType', 'AMOUNT') && !canEditAll) || isMultistaged

        tender.lots = tender.lots?.map(lot => {
          if (withoutPrice) {
            lot.stastPrice = 0
            lot.startAmount = 0
          }
          if (withoutStep) {
            lot.bidStep = 0
          }
          if (!this.$can('set', 'deliveryAddress')) {
            lot.addressId = null
          }
          this.$delete(lot, 'category')
          this.$delete(lot, 'codeCpv')
          return lot
        })
      }

      await this.mixin_checkIndividualsAllowed(tender)
      await this.mixin_checkIsAllowParticipantCancelBid(tender)

      this.minProposalsDate =  await this.mixin_getMinProposalsDate()

      let needSetDate = !tender.tenderId && !tender.tenderPeriodTo && !tender?.biddingType?.withoutPublication // если новый тендер, без даты и дата нужна
      if (oldBiddingType.withoutPublication && !tender?.biddingType?.withoutPublication) { // логика нужна для задачи https://app.clickup.com/t/8696pht67
        needSetDate = true
      }
      if (needSetDate) {
        tender.tenderPeriodTo = this.$_getDateCSharp(await this.mixin_getDefaultProposalsDate())
      }

      let scheduledDate = tender?.tenderPublishedSchedule?.scheduledDate ?? tender.scheduledStart
      if ( scheduledDate ) {
        tender.scheduledStart ||= scheduledDate
      }

      tender.previousMailing = this._processPreviousMailing(tender)
      tender.bidOnAllLots = this.isGroupLotsEnabled ? false : tender.bidOnAllLots
      tender.bidOnAllLotInGroup = this.isGroupLotsEnabled ? tender.bidOnAllLotInGroup : false

      delete tender.tenderPublishedSchedule

      return tender
    },
    async mixin_checkIndividualsAllowed(tender) {
      let is_sale = tender?.biddingType?.isSale

      if (!is_sale) {
        tender.areIndividualsAllowed = false
      } else if (this.$can('set', 'AllowIndividualsParticipation', 'ALWAYS')) {
        tender.areIndividualsAllowed = true
      } else if (is_sale && this.$can('set', 'AllowIndividualsParticipation', 'BY_DEFAULT')) {
        tender.areIndividualsAllowed ??= true
      } else if (this.$can('set', 'AllowIndividualsParticipation', 'NONE')) {
        tender.areIndividualsAllowed = false
      } else {
        tender.areIndividualsAllowed ??= false
      }
    },
    async mixin_checkIsAllowParticipantCancelBid(tender) {
      if (this.$can('set', 'IsAllowParticipantCancelBid', 'ALWAYS_ON')) {
        tender.allowParticipantBidCancellation = true
      } else if (this.$can('set', 'IsAllowParticipantCancelBid', 'SHOW_DEFAULT_OFF')) {
        tender.allowParticipantBidCancellation ??= false
      } else if (this.$can('set', 'IsAllowParticipantCancelBid', 'ALWAYS_OFF')) {
        tender.allowParticipantBidCancellation = false
      } else {
        tender.allowParticipantBidCancellation ??= true
      }
    },
    async mixin_updateRulesForFields(fields, existing_fields) {
      if (!fields?.length) {
        return
      }
      fields.forEach(async (field) => {
        const rulesName = `${existing_fields ? 'existing_fields' : 'additional_fields'}.${field.id}`
        const newRules = await this.$_getValidationByType(
          field?.typeId || field?.type?.typeId,
          field.settingValues.some(set => set.settingType == 'REQUIRED' && eval(set.value))
        )
        this.$emit('changeRules', {[rulesName]: newRules})
      })
    },
    mixin_checkRuEmailDomen(items) {
      const blockDomen = ['ru', 'рф', 'рус', 'su']
      return items.map(i => ({
        ...i,
        blockDomen: blockDomen.some(s => i.email.endsWith(s))
      }))
    },
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      storedCurrentOrganization: 'getCurrentOrganization',
      minPeriodDateOldLogic: 'getMinPproposalsDate',
    }),
    isGroupLotsEnabled() {
      return (this.$can('show', 'useGroupLots') && this.tender?.biddingType?.groupedLotsEnabled) || !!this.tender?.lotGroups?.length
    },
    mixin_formData() {
      let fields = {}
      let existing_fields = {}
      this.additionalFieldsTender?.forEach(field => {
        fields[field.id] = field.value
      })
      this.additionalFieldsTenderExists?.forEach(field => {
        existing_fields[field.id] = field.value
      })
      return {
        ...this.tender,
        additional_fields: fields,
        existing_fields: existing_fields
      }
    },
    mixin_tenderId() {
      return this.tender?.tenderId || (this.$route.query?.id ?? this.$route.params?.id) // TODO: ищем tenderId всеми способами :)
    },
    isAuction() {
      return !!this.tender?.auctionPeriod?.startDate
    },
    mixin_tenderDateMin() {
      const dateToString = (date) => {
        const year = date.getFullYear()
        let month = ('0' + (date.getMonth() + 1)).slice(-2)
        let day = ('0' + date.getDate()).slice(-2)

        return `${year}-${month}-${day}`
      }

      let result = this.tender?.isUrgent
        ? new Date()
        : this.minProposalsDate

      const formattedDate = this.$_getDateCSharp(result)

      return {
        date: result,
        dateSharp: formattedDate,
        dateString: dateToString(result)
      }
    },
  },
  async created() {
    this.$root.$on('changeAdditionalFields', this.mixin_changeAdditionalFields)
    //this.$root.$on('setTenderAdditionalField', this.mixin_setTenderAdditionalField)

  },
  beforeDestroy() {
    this.$root.$off('changeAdditionalFields', this.mixin_changeAdditionalFields)
    //this.$root.$off('setTenderAdditionalField', this.mixin_setTenderAdditionalField)
  },

}
